import { SignalType } from '../../../station-track-visualizer/models/model';

export const zones = [
  { label: 'Central Railway', value: 'Central Railway' },
  { label: 'Eastern Railway', value: 'Eastern Railway' },
  { label: 'East Central Railway', value: 'East Central Railway' },
  { label: 'East Coast Railway', value: 'East Coast Railway' },
  { label: 'Northern Railway', value: 'Northern Railway' },
  { label: 'North Central Railway', value: 'North Central Railway' },
  { label: 'North Eastern Railway', value: 'North Eastern Railway' },
  { label: 'North Frontier Railway', value: 'North Frontier Railway' },
  { label: 'North Western Railway', value: 'North Western Railway' },
  { label: 'Southern Railway', value: 'Southern Railway' },
  { label: 'South Central Railway', value: 'South Central Railway' },
  { label: 'South Eastern Railway', value: 'South Eastern Railway' },
  { label: 'South East Central Railway', value: 'South East Central Railway' },
  { label: 'South Western Railway', value: 'South Western Railway' },
  { label: 'Western Railway', value: 'Western Railway' },
  { label: 'West Central Railway', value: 'West Central Railway' }
];

export const SLIDING_BOOM_SCR_TYPE_OPTIONS = [
  { label: 'SCR Sliding Boom', value: 'SLIDING_BOOM_SCR_SVG' },
  { label: 'SCR Sliding Boom Dotted', value: 'SLIDING_BOOM_SCR_SVG_DOTTED' },
  { label: 'SCR Sliding Boom Type 1', value: 'SLIDING_BOOM_SCR_1_SVG' }
];

export const divisions = [
    { label: 'Vadodara Division, WC Railway', value: 'vadodara' },
    { label: 'Mumbai Division, WC Railway', value: 'mumbai' },
    { label: 'Ratlam Division, WC Railway', value: 'ratlam' }
  ];

export const trainDirections = [
    { label: 'Reverse <-> Nominal', value: 'Reverse <-> Nominal' },
    { label: 'Nominal <-> Reverse', value: 'Nominal <-> Reverse' },
  ];
export const sectionTypes = [
    { label: 'Intermediate Block Section', value: 'Intermediate Block Section' },
  ];

export const adgecentStationsCount = [
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  ];

export const turnOutIdPatternOptions = [
    'A/B',
    'Same Name',
    'Incremental'
  ]

export const surveydataformatOptions = [
    'Asset Distance relative to Asset',
    'Asset Distance relative to center',
  ]

export const colorsExtractionOptions = [ "Black", "Red & Black", "Green & Black", "Red, Green & Black" ];

export const assetCatagories = [
    { label: 'Select category', value: '' },
    { label: 'Advance Starter Signal', value: 'Advance Starter Signal' },
    { label: 'Starter Signal', value: 'Starter Signal' },
    { label: 'Shunt Signal', value: 'Shunt Signal' },
    { label: 'Double Shunt Signal', value:'Double Shunt Signal'},
    { label: 'Stop Board', value: 'Stop Signal' },
    { label: 'Permissive Distant Signal', value: 'Permissive Distant Signal' },
    { label: 'Permissive Inner Distant Signal', value: 'Permissive Inner Distant Signal' },
    { label: 'Permissive Inner Distant Signal Kink', value: 'Permissive Inner Distant Signal Kink' },
    { label: 'Calling Home Signal', value: 'Calling Home Signal' },
    { label: 'Shunt Calling Home Signal', value: 'Shunt Calling Home Signal' },
    { label: 'Advance Starter with B symbol', value: 'Border Signal' },
    { label: 'IB Signal', value: 'Intermediate Block Signal' },
    { label: 'IB with B symbol', value: 'Intermediate Block Border Signal' },
    { label: 'Semi Automatic with B symbol', value: 'Semi Automatic Border Signal' },
    { label: 'Gate Signal', value: 'Gate Signal' },
    { label: 'BSLB Signal', value: 'BSLB Signal' },
    { label: 'SLB Signal', value: 'SLB Signal' },
    { label: 'Shunt-Starter Signal', value: 'Shunt-Starter Signal' },
    { label: 'Automatic Starter Signal', value: 'Automatic Starter Signal' },
    { label: 'Automatic Calling Home Signal', value: 'Automatic Calling Home Signal' },
    { label: 'Automatic Shunt-Starter Signal', value: 'Automatic Shunt-Starter Signal' },
    { label: 'Automatic Gate Signal', value: 'Automatic Gate Signal' },
    { label: 'Semi Automatic Gate Signal', value: 'Semi Automatic Gate Signal' },
    { label: 'Gate Distant Signal', value: 'Gate Distant Signal' },
    { label: 'Gate Inner Distant Signal', value: 'Gate Inner Distant Signal' },
    { label: 'IB Distant Signal', value: 'IB Distant Signal' },
    { label: 'IB Inner Distant Signal', value: 'IB Inner Distant Signal' },
    { label: 'Gate cum IB Distant Signal', value: 'Gate cum IB Distant Signal' },
    { label: 'Gate cum IB Inner Distant Signal', value: 'Gate cum IB Inner Distant Signal' },
    { label: 'Approaching Station Boundary', value: 'Approaching Station Boundary'},
    { label: 'Automatic Signal', value: 'Fully Automatic Signal' },
    { label: 'Semi Automatic Calling Home Signal', value: 'Semi Automatic Calling Home Signal' },
    { label: 'Automatic Gate Calling Home Signal', value: 'Automatic Gate Calling Home Signal' },
    { label: 'Semi Automatic Shunt-Starter Signal', value: 'Semi Automatic Shunt-Starter Signal' },
    { label: 'Semi Automatic Advance Starter with Border Signal', value: 'Semi Automatic Advance Starter with Border Signal' },
    { label: 'Semi Automatic Signal', value: 'Semi Automatic Signal' },
    { label: 'Virtual Signal', value: 'Virtual Signal' },
    { label: 'Dead Stop Signal', value: 'Dead Stop Signal' },
    { label: 'SPT Signal', value: 'SPI Signal' },
    { label: 'SPT Shunt Signal', value: 'SPI Shunt Signal' },
    { label: 'SPT Shunt Calling Home Signal', value: 'SPI Shunt Calling Home Signal' },
    { label: 'Semi Automatic Shunt Calling Home Signal', value: 'Semi Automatic Shunt Calling Home Signal' },
    { label: 'Semi Automatic Gate Calling Home Signal', value: 'Semi Automatic Gate Calling Home Signal'},
    { label: 'Modified Semi Automatic Signal', value: 'Modified Semi Automatic Signal' },
    { label: 'Automatic Advance Starter cum Gate Signal', value: 'Automatic Advance Starter cum Gate Signal'},
    { label: 'Semi Automatic Advance Starter cum Gate Signal', value: 'Semi Automatic Advance Starter cum Gate Signal'},
    { label: 'Automatic Advance Starter cum Gate Signal with b symbol', value: 'Automatic Advance Starter cum Gate Signal with b symbol'},
    { label: 'Semi Automatic Advance Starter cum Gate Signal with b symbol', value: 'Semi Automatic Advance Starter cum Gate Signal with b symbol'},
    { label: 'Gate Cum Distant Signal', value: 'Gate Cum Distant Signal'},
    { label: 'Gate Cum Inner Distant Signal', value: 'Gate Cum Inner Distant Signal'},
    { label: 'Advance Starter Cum Gate Distant Signal with b symbol', value: 'Advance Starter Cum Gate Distant Signal with b symbol'},
    { label: 'Advance Starter Cum IB Distant Signal with b symbol', value: 'Advance Starter Cum IB Distant Signal with b symbol'},
    { label: 'Advance Starter Cum Gate Inner Distant Signal with b symbol', value: 'Advance Starter Cum Gate Inner Distant Signal with b symbol'},
    { label: 'Advance Starter Cum Distant Signal with b symbol', value: 'Advance Starter Cum Distant Signal with b symbol'},
    { label: 'Advance Starter cum Gate Signal with b symbol', value: 'Advance Starter cum Gate Signal with b symbol'},
    { label: 'Advance Starter Cum Gate Distant Signal', value: 'Advance Starter Cum Gate Distant Signal'},
    { label: 'Advance Starter Cum IB Distant Signal', value: 'Advance Starter Cum IB Distant Signal'},
    { label: 'Advance Starter Cum Gate Inner Distant Signal', value: 'Advance Starter Cum Gate Inner Distant Signal'},
    { label: 'Advance Starter Cum Distant Signal', value: 'Advance Starter Cum Distant Signal'},
    { label: 'Advance Starter cum Gate Signal', value: 'Advance Starter cum Gate Signal'},
    { label: 'IB Signal Cum Distant Signal with B symbol', value: 'IB Signal Cum Distant Signal with B symbol'},
    { label: 'IB Signal Cum Inner Distant Signal with B symbol', value: 'IB Signal Cum Inner Distant Signal with B symbol'},
    { label: 'IB Signal Cum Gate Distant Signal with B symbol', value: 'IB Signal Cum Gate Distant Signal with B symbol'},
    { label: 'IB Signal Cum Distant Signal', value: 'IB Signal Cum Distant Signal'},
    { label: 'IB Signal Cum Inner Distant Signal', value: 'IB Signal Cum Inner Distant Signal'},
    { label: 'IB Signal Cum Gate Distant Signal', value: 'IB Signal Cum Gate Distant Signal'},
    { label: 'SPT Semi Automatic Signal', value: 'SPT Semi Automatic Signal'},
    { label: 'Automatic Border Signal', value: 'Automatic Border Signal'},
    { label: 'Automatic Advance Starter Signal', value: 'Automatic Advance Starter Signal'},
    { label: 'Semi Automatic Advance Starter Signal', value: 'Semi Automatic Advance Starter Signal'},
    { label: 'Semi Automatic Starter Signal', value: 'Semi Automatic Starter Signal'},
    { label: 'Calling Home Signal With B Symbol', value: 'Calling Home Signal With B Symbol' },
  ];

export const BORDER_TAG_REVIEW_MESSAGES = {
  N_X_TAG_DETECTED: 'N Tag/X Tag border tags have been detected. Please verify and update their Adjustment Point locations if required.',
  SIGNAL_LOCATION_CHANGED: 'The associated border signal\'s location has changed or been cleared during survey re-upload. Please verify the Adjustment Point.',
  SIGNAL_MISSING: 'The associated border signal could not be found. Please verify the Adjustment Point.'
};

export const COMPONENT_KEYS = {
  STATION_DATA: 'StationDataComponent',
  ADJACENT_STATIONS: 'AdjacentStationsComponent',
  UTILITIES: 'UtilitiesComponent',
  TURNOUTS: 'TurnoutsComponent',
  TRAP_POINTS: 'TrapPointsComponent',
  SIGNALS: 'SignalsV2Component',
  DEAD_ENDS: 'DeadEndsComponent',
  KAVACH_TERRITORY_ENDING: 'KavachTerritoryEndingPointComponent',
  ADJUSTMENT_POINTS: 'AdjustmentPointsComponent'
} 

export const ACTION_KEYS = {
  UPDATE: 'update',
  REGENERATE: 'regenerate'
}

/* Asset categories that force a regenerate when a signal is changed into or out of them.
   Every other asset category change is treated as an update */
export const REGENERATE_ON_CATEGORY_CHANGE: string[] = [
  SignalType.CALLING_HOME_SIGNAL,
  SignalType.AUTOMATIC_CALLING_HOME_SIGNAL,
  SignalType.SEMI_AUTOMATIC_CALLING_HOME_SIGNAL,
  SignalType.SHUNT_CALLING_HOME_SIGNAL,
  SignalType.SPI_SHUNT_CALLING_HOME_SIGNAL,
  SignalType.AUTOMATIC_GATE_CALLING_HOME_SIGNAL,
  SignalType.SEMI_AUTOMATIC_SHUNT_CALLING_HOME_SIGNAL,
  SignalType.SEMI_AUTOMATIC_GATE_CALLING_HOME_SIGNAL,
  // SignalType.STARTER_SIGNAL,
  SignalType.ADVANCE_STARTER_SIGNAL,
  // SignalType.AUTOMATIC_STARTER_SIGNAL,
  // SignalType.SHUNT_STARTER_SIGNAL,
  // SignalType.AUTOMATIC_SHUNT_STARTER_SIGNAL,
  // SignalType.SEMI_AUTOMATIC_SHUNT_STARTER_SIGNAL
  SignalType.AUTOMATIC_ADVANCE_STARTER_CUM_GATE_SIGNAL,
  SignalType.SEMI_AUTOMATIC_ADVANCE_STARTER_CUM_GATE_SIGNAL,
  SignalType.AUTOMATIC_ADVANCE_STARTER_CUM_GATE_SIGNAL_WITH_B_SYMBOL,
  SignalType.SEMI_AUTOMATIC_ADVANCE_STARTER_CUM_GATE_SIGNAL_WITH_B_SYMBOL,
  SignalType.ADVANCE_STARTER_SIGNAL,
  SignalType.ADVANCE_STARTER_CUM_GATE_DISTANT_SIGNAL_WITH_B_SYMBOL,
  SignalType.ADVANCE_STARTER_CUM_IB_DISTANT_SIGNAL_WITH_B_SYMBOL,
  SignalType.ADVANCE_STARTER_CUM_GATE_INNER_DISTANT_SIGNAL_WITH_B_SYMBOL,
  SignalType.ADVANCE_STARTER_CUM_DISTANT_SIGNAL_WITH_B_SYMBOL,
  SignalType.ADVANCE_STARTER_CUM_GATE_SIGNAL_WITH_B_SYMBOL,
  SignalType.ADVANCE_STARTER_CUM_GATE_DISTANT_SIGNAL,
  SignalType.ADVANCE_STARTER_CUM_IB_DISTANT_SIGNAL,
  SignalType.ADVANCE_STARTER_CUM_GATE_INNER_DISTANT_SIGNAL,
  SignalType.ADVANCE_STARTER_CUM_DISTANT_SIGNAL,
  SignalType.ADVANCE_STARTER_CUM_GATE_SIGNAL,
  SignalType.AUTOMATIC_ADVANCE_STARTER_SIGNAL,
  SignalType.SEMI_AUTOMATIC_ADVANCE_STARTER_SIGNAL,
  SignalType.SEMI_AUTOMATIC_ADVANCED_STARTER_WITH_BORDER_SIGNAL,
];


export const TRACK_CIRCUIT_OPTIONS = [
  {
    label: 'Track Circuits',
    items: [
      { label: "IL Bottom Right", type: 'Track Circuits', sub_type: 'IL Bottom Right', id: "il_bottom_right", imgPath: "./../../assets/imgs/circuit_images/svgs/il_bottom_right.svg"},
      { label: "IL Top Left", type: 'Track Circuits', sub_type: 'IL Top Left', id: "il_top_left", imgPath: "./../../assets/imgs/circuit_images/svgs/il_top_left.svg"},
      { label: "IL Top Right", type: 'Track Circuits', sub_type: 'IL Top Right', id: "il_top_right", imgPath: "./../../assets/imgs/circuit_images/svgs/il_top_right.svg"},
      { label: "IL Bottom Left", type: 'Track Circuits', sub_type: 'IL Bottom Left', id: "il_bottom_left", imgPath: "./../../assets/imgs/circuit_images/svgs/il_bottom_left.svg"},
      { label: "L Bottom Right", type: 'Track Circuits', sub_type: 'L Bottom Right', id: "l_bottom_right", imgPath: "./../../assets/imgs/circuit_images/svgs/l_bottom_right.svg"},
      { label: "L Top Left", type: 'Track Circuits', sub_type: 'L Top Left', id: "l_top_left", imgPath: "./../../assets/imgs/circuit_images/svgs/l_top_left.svg"},
      { label: "L Top Right", type: 'Track Circuits', sub_type: 'L Top Right', id: "l_top_right", imgPath: "./../../assets/imgs/circuit_images/svgs/l_top_right.svg"},
      { label: "L Bottom Left", type: 'Track Circuits', sub_type: 'L Bottom Left', id: "l_bottom_left", imgPath: "./../../assets/imgs/circuit_images/svgs/l_bottom_left.svg"},
      { label: "Strict Right", type: 'Track Circuits', sub_type: 'Strict Right', id: "right_bracket", imgPath: "./../../assets/imgs/circuit_images/svgs/right-bracket.svg"},
      { label: "Strict Left", type: 'Track Circuits', sub_type: 'Strict Left', id: "left_bracket", imgPath: "./../../assets/imgs/circuit_images/svgs/left-bracket.svg"},
    ]
  },
  {
    label: 'Axle Counters',
    items:  [
      { label: "Single Axle", type: 'Axle Counters', sub_type: 'Single Axle',  id: "single_axle_counter", imgPath: "./../../assets/imgs/circuit_images/svgs/single_axle_counter_v2.svg"},
      { label: "Single Axle Left", type: 'Axle Counters', sub_type: 'Single Axle Left',  id: "single_axle_counter_left", imgPath: "./../../assets/imgs/circuit_images/svgs/single_axle_counter_v3.svg"},
      { label: "Vertical Single Axle", type: 'Axle Counters', sub_type: 'Vertical Single Axle',  id: "vertical_single_axle_counter", imgPath: "./../../assets/imgs/circuit_images/svgs/single_axle_counter_vertical.svg"},
      { label: "Double Axle", type: 'Axle Counters', sub_type: 'Double Axle', id: "double_axle_counter", imgPath: "./../../assets/imgs/circuit_images/svgs/double_axle_counter_v2.svg"},
      { label: "DC Axle", type: 'Axle Counters', sub_type: 'DC Axle', id: "dc_axle_counter", imgPath: "./../../assets/imgs/circuit_images/svgs/dc_axle_counter.svg"},
      { label: "Horizontal Double Axle", type: 'Axle Counters', sub_type: 'Double Axle horizontal', id: "dc_axle_counter_horizontal", imgPath: "./../../assets/imgs/circuit_images/svgs/double_axle_counter.svg"},
      { label: "Vertical Double Axle", type: 'Axle Counters', sub_type: 'Double Axle vertical', id: "dc_axle_counter_vertical", imgPath: "./../../assets/imgs/circuit_images/svgs/double_axle_counter_vertcial.svg"},
      { label: "Vertical Double Axle v2", type: 'Axle Counters', sub_type: 'Double Axle vertical v2', id: "dc_axle_counter_vertical_v2", imgPath: "./../../assets/imgs/circuit_images/svgs/vertical_double_axle_v2.svg"},
      { label: "Horizontal Double Axle Left", type: 'Axle Counters', sub_type: 'Double Axle horizontal Left', id: "dc_axle_counter_horizontal_left", imgPath: "./../../assets/imgs/circuit_images/svgs/double_axle_counter_left_slant.svg"},
      { label: "Double Axle Counter Straight", type: 'Axle Counters', sub_type: 'Double Axle Counter Straight', id:"double_axle_counter_straight", imgPath:"./../../assets/imgs/circuit_images/svgs/double_axle_counter_straight.svg"},
      { label: "CR Single Axle", type: 'Axle Counters', sub_type: 'CR Single Axle', id: "cr_single_axle_counter", imgPath: "./../../assets/imgs/circuit_images/svgs/single_axle_counter_central.svg"},
      { label: "CR Left Slant Single Axle", type: 'Axle Counters', sub_type: 'CR Left Slant Single Axle', id: "cr_left_slant_single_axle_counter", imgPath: "./../../assets/imgs/circuit_images/svgs/left_slant_single_axle_counter.svg"},
      { label: "CR double Axle", type: 'Axle Counters', sub_type: 'CR Double Axle', id: "cr_double_axle_counter", imgPath: "./../../assets/imgs/circuit_images/svgs/double_axle_counter_central.svg"},
      { label: "CR double Axle v2", type: 'Axle Counters', sub_type: 'CR Double Axle v2', id: "cr_double_axle_counter_v2", imgPath: "./../../assets/imgs/circuit_images/svgs/double_axle_counter_v3.svg"},
      { label: "Dot Axle", type: 'Axle Counters', sub_type: 'Dot Axle', id: "dot_axle_counter", imgPath: "./../../assets/imgs/circuit_images/svgs/dot_axle.svg" },
      { label: "Tc Single ",type: "Axle Counters",sub_type: "Track Circuit single" ,id: "track_circuit_single" ,imgPath: "./../../assets/imgs/circuit_images/Track_Circuit.svg"},
      { label: "Tc Double ",type: "Axle Counters",sub_type: "Track Circuit double",id: "track_circuit_double",imgPath: "./../../assets/imgs/circuit_images/Track_Circuit2.svg"},
      { label: "CR Single Axle Unfilled", type: 'Axle Counters', sub_type: 'CR Single Axle Unfilled', id: "cr_single_axle_counter_unfilled", imgPath: "./../../assets/imgs/circuit_images/svgs/single_axle_counter_central_unfilled.svg"},
    ],
  },
  {
    label: 'Track Points',
    items: [
      { label: "Single Track Point", type: 'Track Points', sub_type: 'Single Track Point', id: "single_track", imgPath: "./../../assets/imgs/circuit_images/svgs/single_track.svg"},
      { label: "Left Slant Single Track Point", type: 'Track Points', sub_type: 'Left Slant Single Track Point', id: "left_slant_single_track", imgPath: "./../../assets/imgs/circuit_images/svgs/left_slant_single_track.svg"},
      { label: "Double Track Point", type: 'Track Points', sub_type: 'Double Track Point', id: "double_track", imgPath: "./../../assets/imgs/circuit_images/svgs/double_track.svg"},
    ],
  }
]

export const BUILDING_IMAGES = [
      { value: 'version_1.png', icon: 'assets/imgs/station_building_imgs/version_1.png' },
      { value: 'version_2.svg', icon: 'assets/imgs/station_building_imgs/version_2.svg' },
      { value: 'version_3.png', icon: 'assets/imgs/station_building_imgs/version_3.png' },
      { value: 'version_4.svg', icon: 'assets/imgs/station_building_imgs/version_4.svg' },
      { value: 'version_5.png', icon: 'assets/imgs/station_building_imgs/version_5.png' },
      { value: 'version_6.svg', icon: 'assets/imgs/station_building_imgs/version_6.svg' },
      { value: 'version_7.svg', icon: 'assets/imgs/station_building_imgs/version_7.svg' },
      { value: 'version_8.svg', icon: 'assets/imgs/station_building_imgs/version_8.svg' },
      { value: 'version_9.svg', icon: 'assets/imgs/station_building_imgs/version_9.svg' },
      { value: 'version_10.svg', icon: 'assets/imgs/station_building_imgs/version_10.svg' },
      { value: 'version_11.svg', icon: 'assets/imgs/station_building_imgs/version_11.svg' },
      { value: 'version_12.svg', icon: 'assets/imgs/station_building_imgs/version_12.svg' },
      { value: 'version_13.svg', icon: 'assets/imgs/station_building_imgs/version_13.svg' },
      { value: 'version_14.svg', icon: 'assets/imgs/station_building_imgs/version_14.svg' },
      { value: 'version_15.svg', icon: 'assets/imgs/station_building_imgs/version_15.svg' },
      { value: 'version_16.svg', icon: 'assets/imgs/station_building_imgs/version_16.svg' },
      { value: 'version_17.svg', icon: 'assets/imgs/station_building_imgs/version_17.svg' },
      { value: 'version_18.svg', icon: 'assets/imgs/station_building_imgs/version_18.svg' },
      { value: 'version_19.svg', icon: 'assets/imgs/station_building_imgs/version_19.svg' },
      { value: 'version_20.svg', icon: 'assets/imgs/station_building_imgs/version_20.svg' },
      { value: 'version_21.svg', icon: 'assets/imgs/station_building_imgs/version_21.svg' },
      { value: 'version_22.svg', icon: 'assets/imgs/station_building_imgs/version_22.svg' },
      { value: 'version_23.svg', icon: 'assets/imgs/station_building_imgs/version_23.svg' },
      { value: 'version_24.svg', icon: 'assets/imgs/station_building_imgs/version_24.svg' },
      { value: 'version_25.svg', icon: 'assets/imgs/station_building_imgs/version_25.svg' },
      { value: 'version_26.svg', icon: 'assets/imgs/station_building_imgs/version_26.svg' },
      { value: 'version_27.svg', icon: 'assets/imgs/station_building_imgs/version_27.svg' },
      { value: 'version_28.svg', icon: 'assets/imgs/station_building_imgs/version_28.svg' },
      { value: 'version_29.svg', icon: 'assets/imgs/station_building_imgs/version_29.svg' },
      { value: 'version_30.svg', icon: 'assets/imgs/station_building_imgs/version_30.svg' },
      { value: 'version_31.svg', icon: 'assets/imgs/station_building_imgs/version_31.svg' },
      { value: 'version_32.svg', icon: 'assets/imgs/station_building_imgs/version_32.svg' },
      { value: 'version_33.svg', icon: 'assets/imgs/station_building_imgs/version_33.svg' },
      { value: 'version_34.svg', icon: 'assets/imgs/station_building_imgs/version_34.svg' },
      { value: 'version_35.svg', icon: 'assets/imgs/station_building_imgs/version_35.svg' },
      { value: 'version_36.svg', icon: 'assets/imgs/station_building_imgs/version_36.svg' },
      { value: 'version_37.svg', icon: 'assets/imgs/station_building_imgs/version_37.svg' },
      { value: 'version_38.svg', icon: 'assets/imgs/station_building_imgs/version_38.svg' },
      { value: 'version_39.svg', icon: 'assets/imgs/station_building_imgs/version_39.svg' },
      { value: 'version_40.svg', icon: 'assets/imgs/station_building_imgs/version_40.svg' },
      { value: 'version_41.svg', icon: 'assets/imgs/station_building_imgs/version_41.svg' },
      { value: 'version_42.svg', icon: 'assets/imgs/station_building_imgs/version_42.svg' },
      { value: 'version_43.svg', icon: 'assets/imgs/station_building_imgs/version_43.svg' },
      { value: 'version_44.svg', icon: 'assets/imgs/station_building_imgs/version_44.svg' },
      { value: 'version_45.svg', icon: 'assets/imgs/station_building_imgs/version_45.svg' },
      { value: 'version_46.svg', icon: 'assets/imgs/station_building_imgs/version_46.svg' },
      { value: 'version_47.svg', icon: 'assets/imgs/station_building_imgs/version_47.svg' },
      { value: 'version_48.svg', icon: 'assets/imgs/station_building_imgs/version_48.svg' },
      { value: 'version_49.svg', icon: 'assets/imgs/station_building_imgs/version_49.svg' },
      { value: 'version_50.svg', icon: 'assets/imgs/station_building_imgs/version_50.svg' },
      { value: 'version_51.svg', icon: 'assets/imgs/station_building_imgs/version_51.svg' },
      { value: 'version_52.svg', icon: 'assets/imgs/station_building_imgs/version_52.svg' },
      { value: 'version_53.svg', icon: 'assets/imgs/station_building_imgs/version_53.svg' },
      { value: 'version_54.svg', icon: 'assets/imgs/station_building_imgs/version_54.svg' },
      { value: 'version_55.svg', icon: 'assets/imgs/station_building_imgs/version_55.svg' },
      { value: 'version_56.svg', icon: 'assets/imgs/station_building_imgs/version_56.svg' },
      { value: 'version_57.svg', icon: 'assets/imgs/station_building_imgs/version_57.svg' },
      { value: 'version_58.svg', icon: 'assets/imgs/station_building_imgs/version_58.svg' },
      { value: 'version_59.svg', icon: 'assets/imgs/station_building_imgs/version_59.svg' },
      { value: 'version_60.svg', icon: 'assets/imgs/station_building_imgs/version_60.svg' },
      { value: 'version_61.svg', icon: 'assets/imgs/station_building_imgs/version_61.svg' },
      ];

    export const COMPASS_IMAGES = [
    { label: 'Default', value: 'default', icon: 'assets/imgs/svgs/compass-arrows/compass-default.svg' },
    { label: 'Arrow Style 1', value: 'style-1', icon: 'assets/imgs/svgs/compass-arrows/compass-style-1.svg' },
    { label: 'Arrow Style 2', value: 'style-2', icon: 'assets/imgs/svgs/compass-arrows/compass-style-2.svg' },
    { label: 'Arrow Style 3', value: 'style-3', icon: 'assets/imgs/svgs/compass-arrows/compass-style-3.svg' },
    { label: 'Arrow Style 4', value: 'style-4', icon: 'assets/imgs/svgs/compass-arrows/compass-style-4.svg' },
    { label: 'Arrow Style 5', value: 'style-5', icon: 'assets/imgs/svgs/compass-arrows/compass-style-5.svg' },
    { label: 'Arrow Style 6', value: 'style-6', icon: 'assets/imgs/svgs/compass-arrows/compass-style-6.svg' },
    { label: 'Arrow Style 7', value: 'style-7', icon: 'assets/imgs/svgs/compass-arrows/compass-style-7.svg' },
    { label: 'Arrow Style 8', value: 'style-8', icon: 'assets/imgs/svgs/compass-arrows/compass-style-8.svg' },
  ];
